<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div id="text">考勤列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small">新增考勤</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openApplyFun(row)">审批</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增考勤' : '编辑考勤'"
      footer-hide
      width="700"
      height="400"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="项目名称" prop="groupId">
              <selectItems
                :name="item.groupName"
                @update:name="item.groupName = $event"
                :id="item.groupId"
                @update:id="item.groupId = $event"
              ></selectItems>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="业务类型" prop="businessType">
              <Select v-model="item.businessType">
                <Option
                  v-for="(x, index) in $t('businessType')"
                  :value="x"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="申报类型" prop="applyType">
              <Select v-model="item.applyType">
                <Option
                  v-for="(x, index) in $t('applyType')"
                  :value="index"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="请假类型" prop="attdType">
              <Select v-model="item.attdType" :disabled="item.applyType != 0">
                <Option
                  v-for="(x, index) in $t('attdType')"
                  :value="index"
                  :key="index"
                  v-show="index != '100'"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="审批人" prop="auditorUser">
              <select-person
                :name="item.auditorUser"
                @update:name="item.auditorUser = $event"
                :id="item.auditorUserId"
                @update:id="item.auditorUserId = $event"
              >
              </select-person>
            </FormItem>
          </Col>

          <Col span="12">
            <FormItem label="开始日期" prop="startTime1">
              <DatePicker
                type="datetime"
                placeholder="请选择"
                v-model="item.startTime1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="结束日期" prop="endTime1">
              <DatePicker
                type="datetime"
                placeholder="请选择"
                v-model="item.endTime1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="调休开始" prop="adjustStime1">
              <DatePicker
                type="datetime"
                placeholder="请选择"
                v-model="item.adjustStime1"
                :disabled="!(item.applyType == '2' || item.applyType == '3')"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="调休结束" prop="adjustEtime1">
              <DatePicker
                type="datetime"
                placeholder="请选择"
                v-model="item.adjustEtime1"
                :disabled="!(item.applyType == '2' || item.applyType == '3')"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="addUpdate('item')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <Modal
      v-model="openApply"
      title="延期申请审批"
      footer-hide
      width="400"
      height="400"
    >
      <Form
        ref="applyItem"
        :model="applyItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="审批" prop="status">
              <RadioGroup v-model="applyItem.status">
                <Radio :label="1">通过</Radio>
                <Radio :label="2">驳回</Radio>
                <Radio :label="3">作废</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button type="primary" @click="apply('applyItem')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import selectPerson from "../common/selectPerson.vue";
export default {
  components: { selectPerson },
  data() {
    return {
      openForm: false,
      openApply: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "申请人",
          key: "addName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "申报类型",
          key: "applyType",
          render: (h, data) => {
            return h("div", this.$t("applyType." + data.row.applyType));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "业务类型",
          key: "businessType",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "请假类型",
          key: "attdType",
          render: (h, data) => {
            return h("div", this.$t("attdType." + data.row.attdType));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "审批状态",
          key: "status",
          render: (h, data) => {
            return h("div", this.$t("applyStatus." + data.row.status));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "调休开始",
          key: "adjustStime",
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.adjustStime, "yymmddhhmm")
            );
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "调休结束",
          key: "adjustEtime",
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.adjustEtime, "yymmddhhmm")
            );
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "开始日期",
          key: "startTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTime, "yymmddhhmm"));
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "结束日期",
          key: "endTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endTime, "yymmddhhmm"));
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "审批人",
          key: "auditorUser",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: 0,
        groupName: "",
        deptId: 0,
        deptName: "",
        auditorUserId: 0, //审批人用户ID
        auditorUser: "", //审批人
        addUserid: 0,
        addName: "", //申请人
        businessType: "清扫保洁", //业务类型(清扫保洁,垃圾清运,综合巡查,绿化管养)
        applyType: "0", //申报类型(0-请假，1-加班，2-调班，3-调体)
        attdType: "0", //	请假类型(0-事假，1-病假，2-婚假，3-产假，4-年假，5-丧假)
        startTime: "",
        endTime: "",
        startTime1: new Date(),
        endTime1: new Date(),
        duration: 0,
        adjustStime: "", //调整开始时间(调班、调休使用)		fal
        adjustEtime: "", //调整结束时间(调班、调休使用)
        adjustStime1: "",
        adjustEtime1: "",
        remark: "",
        status: 0, //审批状态(0-待审，1-已审，2-驳回，3-作废)
      },
      applyItem: {
        ids: "",
        status: 1,
      },
      ruleValidate: {
        groupId: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      now: "",
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/attdManage/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        this.tableData = data;
      });
    },
    addUpdate(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.item.adjustStime = this.utils.toSjc(this.item.adjustStime1);
          this.item.startTime = this.utils.toSjc(this.item.startTime1);
          this.item.endTime = this.utils.toSjc(this.item.endTime1);
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.swm + "/attdManage/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.swm + "/attdManage/update",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.swm + "/attdManage/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
      this.item.adjustStime1 = this.utils.sjcTo(row.adjustStime);
      this.item.startTime1 = this.utils.sjcTo(row.startTime);
      this.item.endTime1 = this.utils.sjcTo(row.endTime);
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    openApplyFun(row) {
      console.log(row);
      this.openApply = true;
      this.applyItem.ids = [row.id].join(",");
      console.log(this.applyItem);
    },
    apply() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/attdManage/updateAuditSataus",
        data: this.applyItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        console.log(res);
        if (res) {
          this.openApply = false;
          this.getList();
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
  computed: {
    applyType() {
      return this.item.applyType;
    },
  },
  watch: {
    applyType(v) {
      if (v != 0) {
        this.item.attdType = "100";
      } else {
        this.item.attdType = "0";
      }
      if (!(v == "2" || v == "3")) {
        this.item.adjustStime1 = "";
        this.item.adjustEtime1 = "";
      } else {
        this.item.adjustStime1 = new Date();
        this.item.adjustEtime1 = new Date();
      }
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/person/attdManage.vue